import React, { useState } from "react";
import { test } from "../../services/api";
import "./TestMessages.css";

function TestMessages() {
  const [textPhone, setTextPhone] = useState("");
  const [textMessage, setTextMessage] = useState("");
  const [textResult, setTextResult] = useState(null);
  const [textSending, setTextSending] = useState(false);

  const [orderPhone, setOrderPhone] = useState("");
  const [orderName, setOrderName] = useState("Test Customer");
  const [orderNumber, setOrderNumber] = useState("TEST-001");
  const [orderTotal, setOrderTotal] = useState("PKR 1000");
  const [orderResult, setOrderResult] = useState(null);
  const [orderSending, setOrderSending] = useState(false);

  const handleSendText = async (e) => {
    e.preventDefault();
    setTextSending(true);
    setTextResult(null);
    try {
      const data = await test.sendTextMessage(textPhone, textMessage);
      setTextResult(data);
    } catch (err) {
      setTextResult({ success: false, error: "Request failed" });
    }
    setTextSending(false);
  };

  const handleSendOrder = async (e) => {
    e.preventDefault();
    setOrderSending(true);
    setOrderResult(null);
    try {
      const data = await test.sendOrderConfirmation({
        phone: orderPhone,
        customerName: orderName,
        orderNumber,
        orderTotal,
      });
      setOrderResult(data);
    } catch (err) {
      setOrderResult({ success: false, error: "Request failed" });
    }
    setOrderSending(false);
  };

  return (
    <div className="test-page">
      <h1>Test WhatsApp Messages</h1>
      <div className="test-grid">
        <div className="test-card">
          <h3>Send Text Message</h3>
          <form onSubmit={handleSendText}>
            <div className="form-group">
              <label>Phone Number (with country code, no +)</label>
              <input value={textPhone} onChange={(e) => setTextPhone(e.target.value)} placeholder="923001234567" required />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea value={textMessage} onChange={(e) => setTextMessage(e.target.value)} placeholder="Hello! Test message..." required rows={3} />
            </div>
            <button type="submit" className="btn-primary" disabled={textSending}>
              {textSending ? "Sending..." : "Send Text Message"}
            </button>
            {textResult && (
              <div className={`result ${textResult.success ? "result-success" : "result-error"}`}>
                {textResult.success ? textResult.message : "Error: " + textResult.error}
              </div>
            )}
          </form>
        </div>

        <div className="test-card">
          <h3>Send Order Confirmation (with buttons)</h3>
          <form onSubmit={handleSendOrder}>
            <div className="form-group">
              <label>Phone Number</label>
              <input value={orderPhone} onChange={(e) => setOrderPhone(e.target.value)} placeholder="923001234567" required />
            </div>
            <div className="form-group">
              <label>Customer Name</label>
              <input value={orderName} onChange={(e) => setOrderName(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Order Number</label>
              <input value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Order Total</label>
              <input value={orderTotal} onChange={(e) => setOrderTotal(e.target.value)} />
            </div>
            <button type="submit" className="btn-primary" disabled={orderSending} style={{ background: "#10b981" }}>
              {orderSending ? "Sending..." : "Send Order Confirmation"}
            </button>
            {orderResult && (
              <div className={`result ${orderResult.success ? "result-success" : "result-error"}`}>
                {orderResult.success ? orderResult.message : "Error: " + orderResult.error}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default TestMessages;
